import { StatusHistory } from "us.collection/reducers/Workflow/Interfaces";

/**
 * @description Get default key for selected tab
 * @param statusList - History status list
 * @returns - Selected key
 */
export const getDefaultTabKey = (
  statusList: Array<StatusHistory>
): Array<string> => {
  try {
    if (statusList.length > 0) {
      return [statusList[0]?.stackId?.toString()];
    }
    return ["-1"];
  } catch {
    return ["-1"];
  }
};

/**
   * Get desending sorted status list
   * @param list - Status list
   * @returns - Status list
   */
export const getSortedHistoryList = (list: Array<StatusHistory>): Array<StatusHistory> => {
  try{
      return list.sort((a: StatusHistory,b: StatusHistory) => {return b.stackId - a.stackId})
  }
  catch(error){
    return list;
  }
}
